"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isBrowser() {
    return typeof window === 'object'
        && typeof document !== 'undefined'
        && typeof HTMLImageElement !== 'undefined'
        && typeof HTMLCanvasElement !== 'undefined'
        && typeof HTMLVideoElement !== 'undefined'
        && typeof ImageData !== 'undefined'
        && typeof CanvasRenderingContext2D !== 'undefined';
}
exports.isBrowser = isBrowser;
//# sourceMappingURL=isBrowser.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/face-api.js/build/commonjs/env/isBrowser.js
 ** module id = 1455
 ** module chunks = 0
 **/